<div id="openExtendsProductInformationdetail" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title mt-0 ng-binding">Información detallada del producto</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body" *ngIf="item != null">
        <div class="form-group">
          <i class="fas fa-info-circle m-r-5"></i>
          <span class="bold">CÓDIGO:</span>
          <span>{{item.code}}</span>
        </div>
        <div class="form-group">
          <i class="fas fa-info-circle m-r-5"></i>
          <span class="bold" *ngIf="item.type_product == typeproduct_good.id">PRODUCTO : </span>
          <span class="bold" *ngIf="item.type_product == typeproduct_service.id">SERVICIO : </span>
          <span>{{item.description}}</span>
        </div>

        <ng-container *ngIf="item.typeprice_id == typeprice_general.id">
          <div class="form-group">
            <label><i class="fas fa-info-circle m-r-5"></i>TIPO PRECIO: Precio general</label>
            <table class="table mb-0 table-sm">
              <thead class="thead-default">
                <tr>
                  <th class="text-center">P. Mínimo</th>
                  <th class="text-center">P. Crédito</th>
                  <th class="text-center">P. Mayorista</th>
                  <th class="text-center">P. General </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">{{toolsService.momeySol()}}{{item.price_general.price_min}}</td>
                  <td class="text-center">{{toolsService.momeySol()}}{{item.price_general.price_credit}}</td>
                  <td class="text-center">{{toolsService.momeySol()}}{{item.price_general.price_wholesaler}}</td>
                  <td class="text-center"><span
                      class="bold text-primary">{{toolsService.momeySol()}}{{item.price_general.price_sale}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
        <ng-container *ngIf="item.typeprice_id == typeprice_unit.id">
          <div class="form-group">
            <div class="table-responsive">
              <table class="table mb-0 table-sm">
                <thead class="thead-default">
                  <tr>
                    <th class="text-center">Unidad Medida</th>
                    <th class="text-center">Equivalencia</th>
                    <th class="text-center">Precio venta</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="item.unitsmeasure.length == 0">
                    <tr>
                      <td colspan="2"><span>No se encontraron registros</span></td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="item.unitsmeasure.length > 0">
                    <tr *ngFor="let unit of item.unitsmeasure">
                      <td class="text-center">{{unit.description}}</td>
                      <td class="text-center">{{unit.equivalence}}</td>
                      <td class="text-center">{{toolsService.momeySol()}}{{unit.price_sale}}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </ng-container>

        <div class="form-group m-b-20">
          <div class="text-center">
            <label><i class="fas fa-info-circle m-r-5"></i>PRECIO PROMEDIO DE COMPRAS:</label>
            <ng-container *ngIf="item.type_product == typeproduct_good.id">
              <div class="d-inline m-l-5">
                <ng-container *ngIf="item.is_control_stock">
                  <span class="text-danger bold f-s-16 m-l-15">
                    <ng-container *ngIf="average_total_purchase == 'No registra datos'">
                      No registra datos
                    </ng-container>
                    <ng-container *ngIf="average_total_purchase != 'No registra datos'">
                      {{toolsService.momeySol()}}{{average_total_purchase}}
                    </ng-container>
                  </span>
                  <span class="m-l-5">por
                    <ng-container *ngFor="let stock of item.productstock">
                      <span class="f-s-11 bold text-success">
                        {{stock.unitprefix}} ({{stock.unidad_plural}})
                      </span>
                    </ng-container>
                  </span>
                  <p class="m-b-0 m-t-4 m-l-15 f-s-11">Calculado en base a
                    <span class="bold">
                      {{average_purchase.summary_quantity}}
                      <ng-container *ngFor="let stock of item.productstock">
                        <span class="f-s-11 bold">({{stock.unidad_plural}})</span>
                      </ng-container>
                    </span>
                    ingresadas por compras
                  </p>
                </ng-container>
                <ng-container *ngIf="!item.is_control_stock">
                  <span>-</span>
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngIf="item.type_product != typeproduct_good.id">
              <span class="m-l-5">No registra</span>
            </ng-container>
          </div>
        </div>


        <div class="form-group">
          <label><i class="fas fa-info-circle m-r-5"></i>ÚLTIMO PRECIO DE COMPRA:</label>
          <ng-container *ngIf="item.type_product == typeproduct_good.id">
            <ng-container *ngIf="item.is_control_stock">
              <ng-container *ngIf="last_price_purchase != null">
                <div class="m-l-20" ng-if="product.type_product == is_bienes.id">
                  <p class="m-b-3">Proveedor : {{last_price_purchase.provider}}</p>
                  <p class="m-b-3">Fecha compra : {{last_price_purchase.date_purchase}}</p>
                  <p class="m-b-3">P.unitario de compra: <span
                      class="m-l-4 bold">{{toolsService.momeySol()}}{{last_price_purchase.price}}</span></p>
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!item.is_control_stock">
              <span>-</span>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="item.type_product != typeproduct_good.id">
            <span>-</span>
          </ng-container>
        </div>
        <div class="form-group">
          <div>
            <label><i class="fas fa-info-circle m-r-5"></i>PRECIO PROMEDIO (De ingresos por compras y almacen):</label>
            <ng-container *ngIf="item.type_product == typeproduct_good.id">
              <div class="d-inline m-l-5">
                <ng-container *ngIf="item.is_control_stock">
                  <span class="text-primary bold f-s-14 m-l-10">
                    <ng-container *ngIf="average_total == 'No registra datos'">
                      No registra datos
                    </ng-container>
                    <ng-container *ngIf="average_total != 'No registra datos'">
                      {{toolsService.momeySol()}}{{average_total}}
                    </ng-container>
                  </span>
                  <span class="m-l-5">por
                    <ng-container *ngFor="let stock of item.productstock">
                      <span class="f-s-11 bold">
                        {{stock.unitprefix}} ({{stock.unidad_plural}})
                      </span>
                    </ng-container>
                  </span>
                  <p class="m-b-0 m-t-4 m-l-15 f-s-11">Calculado en base a
                    <span class="bold">
                      {{average_summary.summary_quantity}}
                      <ng-container *ngFor="let stock of item.productstock">
                        <span class="f-s-11 bold">({{stock.unidad_plural}}) </span>
                      </ng-container>
                    </span>
                    ingresadas por compras y almacen
                  </p>
                </ng-container>
                <ng-container *ngIf="!item.is_control_stock">
                  <span>-</span>
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngIf="item.type_product != typeproduct_good.id">
              <span class="m-l-5">No registra</span>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal">Cerrar ventana</button>
      </div>
    </div>
  </div>
</div>
